module.exports = __webpack_public_path__ + "img/loading.216aeaf1.jpg";